import { List } from 'immutable';
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseEntity, BaseInlineContainer, DefaultButtonsConfig, InlineContainerService, UserService} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { EPrijemnicaStavkaInlineUpdateComponent } from './eprijemnica-stavka-inline-update.component';

//import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'yt-eprijemnica-stavka-dodatni-atribut-update-container',
  templateUrl: './eprijemnica-stavka-dodatni-atribut-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class EPrijemnicaStavkaDodatniAtributUpdateContainer<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
              activatedRoute: ActivatedRoute,
              userService: UserService,
              ){
super(inlineContainerService, activatedRoute, userService);
}
@Input() Level: 'document' | 'item' | 'attribute' = 'document';

  @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

  @Input() NestedInline: boolean = false;

  tempItems: List<T>
  
  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
      this.baseDetailList.tableConfig.DeleteIcon.Visible= false;
      this.baseDetailList.tableConfig.DeleteIcon.Visible = false;
    }
  }
  setItems(items) {
    this.tempItems = items;
    }


  }


